import { render, staticRenderFns } from "./MainNavBar.vue?vue&type=template&id=3f2a3c64&scoped=true"
import script from "./MainNavBar.vue?vue&type=script&lang=js"
export * from "./MainNavBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2a3c64",
  null
  
)

export default component.exports